// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2C7sU","content":"styles_content__1fh2h","buttonIcon":"styles_buttonIcon__3yiBZ"};